export default {
    namespaced: true,
    state: {
        data: [],
        error: false,
        loading: false,
        total: 0,
        perPage: 0,
    },
    mutations: {
        setData: (state, data) => (state.data = data),
        setTotal: (state, total) => (state.total = total),
        setPerPage: (state, perPage) => (state.perPage = perPage),
        setError: (state, error) => (state.error = error),
        removeError: state => (state.error = false),
        loadingProcess: state => (state.loading = true),
        loadingCompleted: state => (state.loading = false),
    },
    actions: {
        async fetchLog({commit}, data) {
            commit("loadingProcess");
            try {
                let result = await axios
                    .get(`/admin/accounts/users`, {params: {page: data.page, sortBy: data.sortBy, sortDesc: data.sortDesc, filter: data.filter}});

                commit("removeError");
                commit("setTotal", result.data.meta.total);
                commit("setPerPage", result.data.meta.per_page);
                commit(
                    "setData",
                    result.data.data.map(x => ({
                        ...x,
                        account_sum: x.main_account + x.blocked_account + x.deposit_account,
                    }))
                );
            } catch (error) {
                commit("setError", error.message ?? "Неизвестная ошибка");
                console.error(error);
            } finally {
                commit("loadingCompleted");
            }
        },
    },
};
